import React from "react";
import { Header } from "./Header";

export const Layout = ({ currentStep = 1, children }) => {
  return (
    <div className="App min-h-screen bg-[#0a0a0a] text-white font-body">
      <Header currentStep={currentStep} />
      <main className="pt-28 sm:pt-32 pb-16 sm:pb-20 min-h-screen flex flex-col items-center">
        <div className="w-full max-w-3xl px-4 sm:px-6">{children}</div>
      </main>
    </div>
  );
};
